<template>
  <div id="page-steppers">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <v-stepper v-model="step">
            <v-stepper-header>
              <v-stepper-step :complete="e6 > 1" step="1">Information Personelle</v-stepper-step>

        <v-divider></v-divider>

         <v-stepper-step :complete="e6 > 2" step="2">Informations relatives à l'église</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e6 > 3" step="3">Informations de contribution</v-stepper-step>

        <v-divider></v-divider>
        <v-stepper-step :complete="e6 > 4" step="4">Informations économiques</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content step="1">
                 <v-btn color="primary" @click.native="step = 2">Continue</v-btn>
                <v-btn color="accent" @click="goBack">Retour</v-btn>
                <v-card color="grey lighten-1">
                  <personal-info></personal-info>
                 
                </v-card>
                
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-btn color="primary" @click.native="step = 3">Continue</v-btn>
                <v-btn color="accent" @click="goBack">Retour</v-btn>
                <v-card color="grey lighten-1" class="mb-5">
                <church-info></church-info>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-btn color="primary" @click.native="step = 4">Continue</v-btn>
                <v-btn color="accent" @click="goBack">Retour</v-btn>
                <v-card color="grey lighten-1" class="mb-5">
                  <contribution></contribution>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="4">
                <v-btn color="primary" @click.native="step = 1">Continue</v-btn>
                <v-btn color="accent" @click="goBack">Retour</v-btn>
                <v-card color="grey lighten-1" class="mb-5">
                  <financial></financial>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import PersonalInfo from './steppers/EditPersonalInfo';
import ChurchInfo from './steppers/ChurchInfo';
import Contribution from './steppers/Contribution';
import Financial from './steppers/Financial';
import Children from './steppers/Children';
export default {
  components: {
    VWidget,
    PersonalInfo,
    ChurchInfo,
    Contribution,
    Financial,
    Children
  },
  data () {
    return {
      step: 1,
      e6: 1
    };
  },
  computed: {
    memberPhoto () {
      const memberPhoto = this.$store.getters.memberPhoto;
      return memberPhoto;
    },
  },
  methods: {
    goBack () {
      this.$router.go(-1);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/form/NewMember.vue